export default __webpack_public_path__ + "static/media/Zeus-10-11.0218d9eb.pdf";